export const UPCOMING_WORK_CSV_COMMAND_ID = 'exportCsv';

export interface UpcomingWorkCsvExport {
    filename: string;
    content: string;
    contentType: 'text/csv;charset=utf-8';
}
